export const play = (
	color = '#403F42'
) => `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.1586 12.8415C15.7716 12.448 15.7716 11.5521 15.1586 11.1585L9.54024 7.55161C8.8747 7.12434 8 7.60223 8 8.39312V15.607C8 16.3978 8.8747 16.8757 9.54024 16.4485L15.1586 12.8415Z" fill="${color}"/>
    </svg>`;
